import { defineMessages } from 'react-intl';

export default defineMessages({
	home_error_loading_user: {
		id: 'home.error.user.loading',
		defaultMessage: "Loading user data failed",
	},
	home_error_updating_user: {
		id: 'home.error.user.updating',
		defaultMessage: "Updating user data failed",
	},
	home_error_loading_studies: {
		id: 'home.error.studies.loading',
		defaultMessage: "Retrieving studies failed",
	},
});



// WEBPACK FOOTER //
// ./src/locales/home.js